<div class="floating-menu z-2">
  <ul class="floating-menu-item-list">
    @for (item of navItems(); track item.route) {
      <li class="floating-menu-item">
        @if (item.isExternal) {
          <a class="floating-menu-item-link" [href]="item.route" (click)="close.emit(true)">
            {{ item.label }}
          </a>
        } @else {
          <a
            class="floating-menu-item-link"
            [routerLink]="item.route"
            [routerLinkActive]="'floating-menu-item-active'"
            (click)="close.emit(true)"
          >
            {{ item.label }}
          </a>
        }
        @if (item.children.length) {
          <ul class="floating-menu-item-list">
            @for (item of navItems(); track item.route) {
              <li class="floating-menu-item">
                @if (item.isExternal) {
                  <a class="floating-menu-item-link" [href]="item.route" (click)="close.emit(true)">
                    {{ item.label }}
                  </a>
                } @else {
                  <a
                    class="floating-menu-item-link"
                    [routerLink]="item.route"
                    [routerLinkActive]="'floating-menu-item-active'"
                    (click)="close.emit(true)"
                  >
                    {{ item.label }}
                  </a>
                }
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>
